import _ from 'underscore';
import { withUiBlock } from '@bingads-webui/uiblocker';

export const uiBlockerPlugin = definePlugin => definePlugin('uiBlocker', [
  'config',
  'gridView',
], ({
  plugins: {
    uiBlocker: {
      el = null,
      getEl = _.noop,
      text,
      delayedLoading,
    } = {},
  } = {},
  i18n = null,
}, gridView) => {
  const loadingText = text || (i18n ? i18n.getString('loadingText') : undefined);
  let unblock = null;

  gridView.on('willReload', () => {
    if (unblock) {
      unblock();
    }
    unblock = withUiBlock(el || getEl() || gridView.el, loadingText, true, delayedLoading);
  });

  gridView.on('didReload', () => {
    if (unblock) {
      unblock();
      unblock = null;
    }
  });
});
